if (!customElements.get('smartcubing-ecosystem-swiper')) {
    customElements.define(
        'smartcubing-ecosystem-swiper',
        class SmartcubingEcosystemSwiper extends HTMLElement {
            constructor() {
                super();
                this.swiperEl = this.querySelector('.smartcubing-ecosystem-swiper__container .swiper');
            }

            connectedCallback() {
                this.initSwiper();
            }

            initSwiper() {
                const prev = this.querySelector('.smartcubing-ecosystem-swiper__navigation .swiper-btn-prev');
                const next = this.querySelector('.smartcubing-ecosystem-swiper__navigation .swiper-btn-next');
                const pagination = this.querySelector('.swiper-pagination');
                const autoplay = this.swiperEl.dataset.autoplay === 'true';
                this.swiper = new Swiper(this.swiperEl, {
                    // allowTouchMove: false,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    autoHeight: true,
                    navigation: {
                        prevEl: prev,
                        nextEl: next,
                    },
                    pagination: {
                        el: pagination,
                        clickable: true,
                    },
                    autoplay: autoplay ? {
                        pauseOnMouseEnter: true,
                    } : false,
                })
            }
        }
    );
}
